import {
    Badge,
    Button,
    Icon,
    Label,
    Select,
    TextField,
    TextStyle,
    Tooltip,
  } from '@shopify/polaris';  
  import  AttributeRecommendations from '../global/AttributeRecommendations';
  //import Configurables from './components/global/Configurables';

  import '../global/configurables.scss';
  import App from '../../App';
  import {
    CircleInformationMajor,
  } from '@shopify/polaris-icons';

  //flag for is numeric range meta
  let isMetaNumericRange = false;

  function Configurables(props) {
    //console.log('Configs Props');
    //just for test meta range
    if(props.configurables.attribute_key == 'custom_tPkHE1ax2h8TudvK0g9FpogIg7zdZv'){
      //console.log(JSON.stringify(props.configurables));
      //console.log('type: '+typeof(props.configurables.fields));
    }
    //const plans = props.plans;
    //const boxHeight = props.boxHeight
    //const planUrl = props.planUrl;
    //const storeUrl = props.StoreUrl;

    //add or remove option for numeric range
    if(
      props.configurables.type == 'multiform'
      &&
      props.configurables.fields
      &&
      props.configurables.fields.length > 3
      //props.configurables.fields[3].value != 'numeric-range'
      ) {
        if(props.configurables.fields[3].value != 'numeric-range'){
          //console.log('remove numeric range option');
          isMetaNumericRange = false;
        } else {
          //console.log('keep numeric range option');
          isMetaNumericRange = true;
        }
    } 
  
    return (
      renderConfigurablesItem(props)
    );
  }
  function getNamespaceOptions(metaData){
    let options = [];
    options.push({value:'',label:'Select'});

    for (const nameSpace in metaData) {
      options.push({value:nameSpace,label:nameSpace});
    }

    return options;
  }
  function getKeyOptions(namespaceItems){
    //console.log('getKeyOptions');
    //console.log(namespaceItems);
    let options = [];
    if(Array.isArray(namespaceItems)){
      for (let i = 0; i < namespaceItems.length; i++) {
        options.push({value:namespaceItems[i],label:namespaceItems[i]});
      }
    }
    return options;
  }
  function renderConfigurablesItem(props){

    const onChange = (value,attributeKey,fieldKey) => {
      //console.log('configurables onChange: '+value+' ak: '+attributeKey+' fk:'+fieldKey);
      props.change(value,attributeKey,fieldKey);
    }
    const onChangeTitle = (value,attributeKey) => {
      //console.log('configurables onChangeTitle: '+value+' ak: '+attributeKey);
      props.changeTitle(value,attributeKey);
    }
    const onSave = (attributeKey) => {
      //console.log('onSave ak: '+attributeKey);
      props.save(attributeKey);
    }

    switch(props.configurables.type) {
        case 'minMax':
          return <>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              <h3>
                <TextStyle variation="strong">{props.configurables.name}</TextStyle>
              </h3>
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
              <div className="iec-flex-container">
                <div className='configurable-half'>
                  <div className='configurable-half-field'>
                    <TextField
                        label={props.configurables.fields[0].label}
                        value={props.configurables.fields[0].value}
                        //onChange={handleChange}
                        //autoComplete="off"
                        step={1}
                        type="number"
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                        disabled={(props.init.generating_attr_values)}
                    />  
                  <AttributeRecommendations
                    //props={props}
                    label={'Recommended'}
                    shop={props.shop}
                    configurables={props.configurables}
                    suggestionKey={'recommended_min'}
                    tooltip={'Recommended Min'}
                    //configurables={props.configurables}
                  /> 
                  </div>
                </div>
                <div className='configurable-half'>
                  <div className='configurable-half-field'>
                    <TextField
                        label={props.configurables.fields[1].label}
                        value={props.configurables.fields[1].value}
                        //onChange={handleChange}
                        //autoComplete="off"
                        step={1}
                        type="number"
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,1)}}
                        disabled={(props.init.generating_attr_values)}
                    />  
                  <AttributeRecommendations
                    //props={props}
                    label={'Recommended'}
                    shop={props.shop}
                    configurables={props.configurables}
                    suggestionKey={'recommended_max'}
                    tooltip={'Recommended Max'}
                    //configurables={props.configurables}
                  /> 
                  </div> 
                  <div className='configurable-half-button'>
                    <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               
                  </div>
                </div>
              </div>
            </div>                                              
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
              <Tooltip content={props.configurables.tooltip}>
                <p><Icon source={CircleInformationMajor} color="base" /></p>
              </Tooltip>
            </div>  
          </>;
          case 'blank':
            return <>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              <h3>
                <TextStyle variation="strong">{props.configurables.name}</TextStyle>
              </h3>
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">

            </div>  
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
                <Tooltip content={props.configurables.tooltip}>
                  <p><Icon source={CircleInformationMajor} color="base" /></p>
                </Tooltip>
              </div>  
            </>;
          case 'multiform':
              return <>
              <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
                {(props.group == 'custom') ?<TextField
                    value={props.configurables.name}
                    onChange={(value) => {onChangeTitle(value,props.configurables.attribute_key)}}
                    autoComplete="off"
                    type="text"
                    label="Title"
                    labelHidden={false}
                    placeholder={'Attribute name'}
                    disabled={(props.init.generating_attr_values)}
                  /> :<h3><TextStyle variation="strong">{props.configurables.name}</TextStyle></h3> }
              </div>
              <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
                {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
              </div>
              <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
                <div className="attribute-multiform-container">
                  <div className="iec-flex-container">
                    <Select
                      onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                      label={props.configurables.fields[0].label}
                      options={props.configurables.fields[0].options}
                      value={props.configurables.fields[0].value}
                      labelHidden={false}
                    />
                  </div>
                  <div className={((props.configurables.fields[0].value=='metafield'?'show':'hide')+" attributes-resource-item-meta-container")}>
                    <div className="iec-flex-container-meta">
                      <Select
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,1)}}
                        label={props.configurables.fields[1].label}
                        options={getNamespaceOptions(props.metaData)}
                        value={props.configurables.fields[1].value}
                        labelHidden={false}
                      />
                    </div>
                    <div className="iec-flex-container-meta">
                      <Select
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,2)}}
                        label={props.configurables.fields[2].label}
                        options={getKeyOptions(props.metaData[props.configurables.fields[1].value])}
                        value={props.configurables.fields[2].value}
                        labelHidden={false}
                      />
                    </div>                    
                  </div>
                  {
                    (
                      props.configurables.fields[3]
                      &&
                      props.configurables.fields[4]
                    )?
                    <div className="iec-flex-container">
                    <Select
                      onChange={(value) => {onChange(value,props.configurables.attribute_key,3)}}
                      label={props.configurables.fields[3].label}
                      options={props.configurables.fields[3].options}
                      value={props.configurables.fields[3].value}
                      labelHidden={true}
                    />
                      {
                        (isMetaNumericRange)?
                        <>
                        <TextField
                          value={props.configurables.fields[4].value}
                          onChange={(value) => {onChange(value,props.configurables.attribute_key,4)}}
                          autoComplete="off"
                          type="text"
                          label="Mimimum"
                          labelHidden={true}
                          placeholder={'Minimum'}
                          disabled={(props.init.generating_attr_values)}
                        /> 
                        <TextField
                          value={props.configurables.fields[5].value}
                          onChange={(value) => {onChange(value,props.configurables.attribute_key,5)}}
                          autoComplete="off"
                          type="text"
                          label="Maximum"
                          labelHidden={true}
                          placeholder={'Maximum'}
                          disabled={(props.init.generating_attr_values)}
                        /> 
                        </>
                        :
                        <TextField
                          value={props.configurables.fields[4].value}
                          onChange={(value) => {onChange(value,props.configurables.attribute_key,4)}}
                          autoComplete="off"
                          type="text"
                          label="Value"
                          labelHidden={true}
                          placeholder={'Value to match'}
                          disabled={(props.init.generating_attr_values)}
                        /> 
                      }
 
                    <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               

                 </div>
                 :
                 ''

                  }
                  
                </div>
                </div>   
                <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
                <Tooltip content={props.configurables.tooltip}>
                  <p><Icon source={CircleInformationMajor} color="base" /></p>
                </Tooltip>
              </div> 
              </>;
          case 'selectAndText':
                return <>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              <h3>
                <TextStyle variation="strong">{props.configurables.name}</TextStyle>
              </h3>
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
                <div className="attribute-ui-label">
                  <Label>{props.configurables.fields[0].label }</Label>
                </div>
              <div className="iec-flex-container attribute-select-container">
                <Select 
                  label={props.configurables.fields[0].label}
                  options={props.configurables.fields[0].options}
                  value={props.configurables.fields[0].value}
                  labelHidden={true}
                  onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                />
                <TextField
                  value={props.configurables.fields[1].value}
                  autoComplete="off"
                  type="text"
                  label="Value"
                  labelHidden={true}
                  onChange={(value) => {onChange(value,props.configurables.attribute_key,1)}}
                  disabled={(props.init.generating_attr_values)}
                  /> 
                    <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               
              </div>    
              </div>      
              <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
              <Tooltip content={props.configurables.tooltip}>
                  <p><Icon source={CircleInformationMajor} color="base" /></p>
                </Tooltip>
              </div>                 
            </>;
          case 'select':
                return <>                                 
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              <h3>
                <TextStyle variation="strong">{props.configurables.name}</TextStyle>
              </h3>
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
              <div class="attribute-select-container">
                <div className="attribute-ui-label">
                  <Label>{props.configurables.fields[0].label }</Label>
                </div>
                <Select 
                  label={props.configurables.fields[0].label}
                  options={props.configurables.fields[0].options}
                  value={props.configurables.fields[0].value}
                  labelHidden={true}
                  onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                /> 
                    <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               
              </div>
            </div>    
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
              <Tooltip content={props.configurables.tooltip}>
                <p><Icon source={CircleInformationMajor} color="base" /></p>
              </Tooltip>
              </div> 
            </>;
            case 'select': {/* wtf there are 2 selects? */}
                return <>                                 
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              <h3>
                <TextStyle variation="strong">{props.configurables.name}</TextStyle>
              </h3>
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
              <div class="attribute-select-container">
                <div className="attribute-ui-label">
                  <Label>{props.configurables.fields[0].label }</Label>
                </div>
                <Select 
                  label={props.configurables.fields[0].label}
                  options={props.configurables.fields[0].options}
                  value={props.configurables.fields[0].value}
                  labelHidden={true}
                  onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                /> 
                    <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               
              </div>
            </div>    
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
              <Tooltip content={props.configurables.tooltip}>
                <p><Icon source={CircleInformationMajor} color="base" /></p>
              </Tooltip>
              </div> 
            </>;
          case 'partner':
            return <>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-1">
              {(props.group == 'partner') ?<TextField
                  value={props.configurables.name}
                  onChange={(value) => {onChangeTitle(value,props.configurables.attribute_key)}}
                  autoComplete="off"
                  type="text"
                  label="Title"
                  labelHidden={false}
                  placeholder={'Attribute name'}
                  disabled={(props.init.generating_attr_values)}
                  /> :<h3><TextStyle variation="strong">{props.configurables.name}</TextStyle></h3> }
            </div>
            
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-2">
              {props.configurables.status == "1"? <Badge status="success">Active</Badge>:<Badge>Inactive</Badge>}
            </div>
            <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-3">
              <div className="attribute-multiform-container">
              
                  <div className="iec-flex-container">
                    <Select
                      onChange={(value) => {onChange(value,props.configurables.attribute_key,0)}}
                      label={props.configurables.fields[0].label}
                      options={props.configurables.fields[0].options}
                      value={props.configurables.fields[0].value}
                      labelHidden={false}
                    />
                  </div>

                  <div className={" attributes-resource-item-meta-container"}>
                    <div className="iec-flex-container-meta">
                      <Select
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,1)}}
                        label={props.configurables.fields[1].label}
                        options={props.configurables.fields[1].options}
                        value={props.configurables.fields[1].value}
                        labelHidden={false}
                      />
                    </div>
                    <div className="iec-flex-container-meta">
                      <Select
                        onChange={(value) => {onChange(value,props.configurables.attribute_key,2)}}
                        label={props.configurables.fields[2].label}
                        options={props.configurables.fields[2].options}
                        value={props.configurables.fields[2].value}
                        labelHidden={false}
                      />
                    </div>                  
                  </div>
                  <div className={" attributes-resource-item-meta-container"}>
                    <div className="iec-flex-container-meta">
                      <TextField
                      value={props.configurables.fields[3].value}
                      autoComplete="off"
                      type="text"
                      label="Value"
                      labelHidden={true}
                      onChange={(value) => {onChange(value,props.configurables.attribute_key,3)}}
                      disabled={(props.init.generating_attr_values)}
                      /> 
                    </div>

                    <div className={((props.configurables.fields[2].value=='between'?'show':'hide')+" iec-flex-container-meta")}>
                      <TextField
                      value={props.configurables.fields[4].value}
                      autoComplete="off"
                      type="text"
                      label="Value"
                      labelHidden={true}
                      onChange={(value) => {onChange(value,props.configurables.attribute_key,4)}}
                      disabled={(props.init.generating_attr_values)}
                      /> 
                    </div>
                  </div>
                </div>
                <Button disabled={(props.configurables.saveable == "1"? false:true)} primary onClick={() => {onSave(props.configurables.attribute_key)}}>Save</Button>               

            </div>   
              <div className="resource-item-col attributes-resource-item-col attributes-resource-item-col-4">
              <Tooltip content={props.configurables.tooltip}>
                <p><Icon source={CircleInformationMajor} color="base" /></p>
              </Tooltip>
            </div> 
            </>;
            default:
          return '';
      }    
      return '';
  }

  export default Configurables;
